var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site2026"},[_c('Site2026Header'),_c('div',{staticClass:"nav-spacer"}),_c('main',{ref:"main"},[_c('router-view',{key:_vm.$route.path})],1),_c('Site2026Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }